// PDF scores live ONLY in this browser (IndexedDB) — never uploaded. Keyed per song so reopening a
// song brings back its sheet and its detected measures.
import { openDB, type IDBPDatabase } from "idb";
import type { Box } from "../core/pdf/detectMeasures";
import type { SongSource } from "../types/domain";

export interface PageInfo { measures: Box[]; aspect: number }   // aspect = height / width
export interface StoredScore {
  key: string;
  name: string;
  pdf: ArrayBuffer;
  pages: PageInfo[];
  detector?: number;    // DETECTOR_VERSION the boxes came from; older → re-detect on open
  updatedAt: number;
}

// bump whenever detectMeasures / multi-rest counting changes, so saved sheets get re-detected
export const DETECTOR_VERSION = 3;   // 3: repeats, voltas, grand-staff stem fix

let dbp: Promise<IDBPDatabase> | null = null;
function db() {
  // v2: (re)create the store if missing — a database opened elsewhere without it would block saving forever
  if (!dbp) dbp = openDB("tutti-pdf", 2, {
    upgrade(d) { if (!d.objectStoreNames.contains("scores")) d.createObjectStore("scores", { keyPath: "key" }); },
  });
  return dbp;
}

export function songKey(src: SongSource, title: string): string | null {
  if (src.kind === "youtube") return "yt:" + src.videoId;
  if (src.kind === "localFile") return "file:" + (src.fileName || title);
  return null;
}

export async function loadScore(key: string): Promise<StoredScore | undefined> {
  return (await db()).get("scores", key);
}
/** whether this device holds a sheet for the song (no PDF bytes read) */
export async function hasScore(key: string): Promise<boolean> {
  return (await (await db()).getKey("scores", key)) !== undefined;
}
export async function saveScore(s: StoredScore): Promise<void> {
  await (await db()).put("scores", { ...s, updatedAt: Date.now() });
}
export async function deleteScore(key: string): Promise<void> {
  await (await db()).delete("scores", key);
}
